module.exports = __webpack_public_path__ + "static/media/charity.5ddc7dc3.png";